import useConfirmDialog from "../../features/modal/ConfirmDialog";
import "./Stepper.css";
import {
  fetchFasesTrabajo,
  createEDT,
  fetchCategoriaNombreImagen,
  fetchTipoParametrosTrabajo,
  deleteCategoriaNombreImagen,
  deleteTipoParametrosTrabajo,
  cambiarOrdenTipoParametrosTrabajo,
  cambiarOrdenCategoriaNombreImagen,
} from "../../components/functions/Projects";
import LoaderDialog from "../../ui/loader/Loader";
import EDTCategoriaImagenModal from "../edtModal/EDTCategoriaImagenModal";
import EDTParametroModal from "../edtModal/EDTParametroModal";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import {
  Box,
  Typography,
  Paper,
  Stepper,
  Step,
  StepLabel,
  Snackbar,
  Tabs,
  Tab,
  Popper,
} from "@mui/material";
import ConfirmDialog from "../../features/imagenesModal/dialogs/ConfirmDialog";
import {
  useState,
  useEffect,
  useRef,
  useMemo,
  useImperativeHandle,
  forwardRef,
} from "react";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import Ajustes from "../../assets/img/svg/users/opciones.svg";
import Editar from "../../assets/img/svg/users/editar.svg";
import Eliminar from "../../assets/img/svg/users/eliminar.svg";
import "react-multi-carousel/lib/styles.css";
import CustomButton from "../../ui/button/Button";

const steps = [
  "Estructura de desgloce de trabajo",
  "Categoría de imagen",
  "Parámetro",
];

const EDTStepper = forwardRef(
  (
    { API_URL, typeWorks, newProject = false, handleComplete = () => {} },
    ref
  ) => {
    const showDialog = useConfirmDialog();
    const [showLoader, setShowLoader] = useState(false);
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");

    const [activeStep, setActiveStep] = useState(0);
    const [nombre, setNombre] = useState("");
    const [fasesDeTrabajo, setFasesDeTrabajo] = useState([]);

    const [parametros, setParametros] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [selectedFaseDeTrabajo, setSelectedFaseDeTrabajo] = useState(null);
    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const [openMenuIndex2, setOpenMenuIndex2] = useState(null);
    const [showConfirm, setShowConfirm] = useState({
      show: false,
      title: "",
      content: "",
      type: "",
    });
    const [data, setData] = useState([]);

    const [openCategoriaModal, setOpenCategoriaModal] = useState(false);
    const [openParametroModal, setOpenParametroModal] = useState(false);

    const [selectedCategoria, setSelectedCategoria] = useState(null);
    const [selectedParametro, setSelectedParametro] = useState(null);

    const [isEdit, setIsEdit] = useState(false);
    const [selectedEDT, setSelectedEDT] = useState(null);

    useImperativeHandle(ref, () => ({
      handleNext: handleNext,
    }));

    useEffect(() => {
      const fetchParametros = async () => {
        try {
          setShowLoader(true);
          if (activeStep === 2) {
            const response = await fetchTipoParametrosTrabajo(
              API_URL,
              selectedEDT.id,
              selectedFaseDeTrabajo?.name
            );
            setParametros([...response]);
            setData([...response]);
            setOpenMenuIndex(null);
            setOpenMenuIndex2(null);
          } else if (activeStep === 1) {
            const response = await fetchCategoriaNombreImagen(
              API_URL,
              selectedEDT.id,
              selectedFaseDeTrabajo?.name
            );
            setCategorias([...response]);
            setData([...response]);
            setOpenMenuIndex(null);
            setOpenMenuIndex2(null);
          }
          setShowLoader(false);
        } catch (error) {
          setShowLoader(false);
          console.error("Error fetching parametros:", error);
        }
      };
      if (selectedFaseDeTrabajo && selectedEDT && activeStep > 0) {
        fetchParametros();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeStep, selectedFaseDeTrabajo]);

    const columnsParametros = useMemo(
      () => [
        { accessorKey: "orden", header: "Orden", size: 10 },
        { accessorKey: "nombre", header: "Nombre", size: 50 },
        { accessorKey: "tipoParametro.descripcion", header: "Tipo", size: 50 },
        {
          accessorKey: "categoriaReporte.nombre",
          header: "Categoría de reporte",
          size: 50,
        },
        {
          accessorKey: "acciones",
          header: "Acciones",
          size: 40,
          Cell: ({ row }) => {
            const anchorRef = useRef(null);
            const isOpen = openMenuIndex === row.index;
            return (
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <button
                  ref={anchorRef}
                  onClick={() => {
                    setOpenMenuIndex((prev) =>
                      prev === row.index ? null : row.index
                    );
                    setSelectedParametro(row.original);
                  }}
                  className="action-icon"
                >
                  <img
                    src={Ajustes}
                    alt="Ajustes"
                    style={{ width: 20, height: 20 }}
                  />
                </button>

                <Popper
                  open={isOpen}
                  anchorEl={anchorRef.current}
                  placement="bottom-start"
                  style={{ zIndex: 9999999 }}
                >
                  <div
                    className="dropdown-menu-user"
                    style={{
                      background: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: 4,
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                      marginTop: 5,
                      padding: 5,
                      minWidth: 100,
                    }}
                  >
                    <p
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        padding: "5px 10px",
                      }}
                      onClick={() => {
                        setIsEdit(true);
                        // setSelectedParametro(row.original);
                        setOpenParametroModal(true);
                        setOpenMenuIndex(null);
                      }}
                    >
                      <img
                        src={Editar}
                        alt=""
                        style={{ width: 16, height: 16, marginRight: 8 }}
                      />
                      Editar
                    </p>
                    <p
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        padding: "5px 10px",
                      }}
                      onClick={() => {
                        setShowConfirm({
                          show: true,
                          title: "Confirmación",
                          content:
                            "¿Estás seguro que deseas eliminar el parámetro?",
                          type: "eliminarParametro",
                        });
                        setOpenMenuIndex(null);
                      }}
                    >
                      <img
                        src={Eliminar}
                        alt=""
                        style={{ width: 16, height: 16, marginRight: 8 }}
                      />
                      Borrar
                    </p>
                  </div>
                </Popper>
              </div>
            );
          },
        },
      ],
      [openMenuIndex]
    );

    const columnsCategoriasMemo = useMemo(
      () => [
        { accessorKey: "orden", header: "Orden", size: 10 },
        { accessorKey: "nombre", header: "Nombre", size: 50 },
        {
          accessorKey: "acciones",
          header: "Acciones",
          size: 40,
          Cell: ({ row }) => {
            const anchorRef = useRef(null);
            const isOpen = openMenuIndex2 === row.index;
            return (
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <button
                  ref={anchorRef}
                  onClick={() => {
                    setOpenMenuIndex2((prev) =>
                      prev === row.index ? null : row.index
                    );
                    setSelectedCategoria(row.original);
                  }}
                  className="action-icon"
                >
                  <img
                    src={Ajustes}
                    alt="Ajustes"
                    style={{ width: 20, height: 20 }}
                  />
                </button>
                <Popper
                  open={isOpen}
                  anchorEl={anchorRef.current}
                  placement="bottom-start"
                  style={{ zIndex: 9999 }}
                >
                  <div
                    className="dropdown-menu-user"
                    style={{
                      background: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: 4,
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                      marginTop: 5,
                      padding: 5,
                      minWidth: 100,
                    }}
                  >
                    <p
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        padding: "5px 10px",
                      }}
                      onClick={() => {
                        setIsEdit(true);
                        // setSelectedCategoria(row.original);
                        setOpenCategoriaModal(true);
                        setOpenMenuIndex2(null);
                      }}
                    >
                      <img
                        src={Editar}
                        alt=""
                        style={{ width: 16, height: 16, marginRight: 8 }}
                      />
                      Editar
                    </p>
                    <p
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        padding: "5px 10px",
                      }}
                      onClick={() => {
                        setShowConfirm({
                          show: true,
                          title: "Confirmación",
                          content:
                            "¿Estás seguro que deseas eliminar la categoría?",
                          type: "eliminarCategoria",
                        });
                        setOpenMenuIndex2(null);
                      }}
                    >
                      <img
                        src={Eliminar}
                        alt=""
                        style={{ width: 16, height: 16, marginRight: 8 }}
                      />
                      Borrar
                    </p>
                  </div>
                </Popper>
              </div>
            );
          },
        },
      ],
      [openMenuIndex2]
    );

    const columnsToUse =
      activeStep === 2 ? columnsParametros : columnsCategoriasMemo;

    const table = useMaterialReactTable({
      autoResetPageIndex: false,
      columns: columnsToUse,
      data,
      enableRowOrdering: true,
      enableSorting: false,
      enableFilters: false,
      enableTopToolbar: false,
      enableColumnActions: false,
      getRowId: (originalRow) => originalRow.id,
      positionToolbarAlertBanner: "none",
      localization: MRT_Localization_ES,
      layoutMode: "grid",
      defaultColumn: {
        minSize: 40,
        size: 80,
      },
      muiRowDragHandleProps: ({ table }) => ({
        onDragEnd: () => {
          const { draggingRow, hoveredRow } = table.getState();
          if (hoveredRow && draggingRow) {
            data.splice(
              hoveredRow.index,
              0,
              data.splice(draggingRow.index, 1)[0]
            );
            setData([...data]);
          }
        },
      }),
    });

    const handleNext = async () => {
      switch (activeStep) {
        case 0:
          if (nombre.trim() === "") {
            showDialog({
              html: "El nombre es obligatorio.",
              icon: "warning",
              confirmButtonText: "Aceptar",
              mostrarCancelar: false,
            });
            return;
          }

          const duplicate = typeWorks.find(
            (item) => item.nombre === nombre.toUpperCase()
          );

          if (duplicate) {
            showDialog({
              html: "La estructura de desglose de trabajo ingresada ya existe.",
              icon: "warning",
              confirmButtonText: "Aceptar",
              mostrarCancelar: false,
            });
            return null;
          }

          try {
            setShowLoader(true);
            const newEDT = await createEDT(API_URL, { nombre });

            setSelectedEDT(newEDT);

            const fasesRes = await fetchFasesTrabajo(API_URL, newEDT.id);

            fasesRes.forEach((fase) => {
              if (fase.descripcion === "Entregable") {
                fase.descripcion = "Implementación";
              }
            });

            setSelectedFaseDeTrabajo(fasesRes[0]);

            const response = await fetchCategoriaNombreImagen(
              API_URL,
              newEDT.id,
              fasesRes[0]?.name
            );
            setCategorias([...response]);
            setData([...response]);
            setOpenMenuIndex(null);
            setOpenMenuIndex2(null);

            setFasesDeTrabajo(fasesRes);
            setActiveStep((prev) => prev + 1);
            setShowLoader(false);
            setShowSnackbar(true);
            setSnackbarMessage(
              "Estructura de desglose de trabajo creado con éxito"
            );
          } catch (error) {
            setShowLoader(false);
            setShowSnackbar(true);
            setSnackbarMessage(
              "Ocurrió un error al crear la estructura de desglose de trabajo"
            );
          }

          break;
        case 1:
          if (data.length === 0) {
            showDialog({
              html: "Se debe agregar al menos una categoría de imagen.",
              icon: "warning",
              confirmButtonText: "Aceptar",
              mostrarCancelar: false,
            });
            return;
          }
          setActiveStep((prev) => prev + 1);
          break;
        case 2:
          if (data.length === 0) {
            showDialog({
              html: "Se debe agregar al menos un parámetro.",
              icon: "warning",
              confirmButtonText: "Aceptar",
              mostrarCancelar: false,
            });
            return;
          }

          try {
            setActiveStep((prev) => prev + 1);
            if (newProject) {
              handleComplete(selectedEDT);
            } else {
              showDialog({
                html: "Todos los pasos se han completado con éxito. Ahora puedes regresar al listado de Estructuras de Desglose de Trabajo.",
                icon: "success",
                confirmButtonText: "Aceptar",
                mostrarCancelar: false,
              });
            }
          } catch (error) {
            setShowLoader(false);
            setShowSnackbar(true);
            setSnackbarMessage("Ocurrió un error al crear el parámetro");
          }
          break;
        default:
          break;
      }
    };

    const handleCategoriaModalClose = async () => {
      setOpenCategoriaModal(false);
      setSelectedCategoria(null);
      setIsEdit(false);

      const response = await fetchCategoriaNombreImagen(
        API_URL,
        selectedEDT.id,
        selectedFaseDeTrabajo?.name
      );
      setCategorias([...response]);
      setData([...response]);
    };

    const handleParametroModalClose = async () => {
      setOpenParametroModal(false);
      setSelectedParametro(null);
      setIsEdit(false);

      const response = await fetchTipoParametrosTrabajo(
        API_URL,
        selectedEDT.id,
        selectedFaseDeTrabajo?.name
      );
      setParametros([...response]);
      setData([...response]);
    };

    const handleDeleteParametro = async () => {
      try {
        setShowLoader(true);
        await deleteTipoParametrosTrabajo(API_URL, selectedParametro.id);
        setParametros((prev) =>
          prev.filter((p) => p.id !== selectedParametro.id)
        );
        setData((prev) => prev.filter((p) => p.id !== selectedParametro.id));
        setShowLoader(false);
        setShowSnackbar(true);
        setSnackbarMessage("Parámetro eliminado correctamente");
      } catch (error) {
        setShowLoader(false);
        setShowSnackbar(true);
        setSnackbarMessage("Error al eliminar el parámetro");
      }
    };

    const handleDeleteCategoria = async () => {
      try {
        setShowLoader(true);
        await deleteCategoriaNombreImagen(API_URL, selectedCategoria.id);
        setCategorias((prev) =>
          prev.filter((c) => c.id !== selectedCategoria.id)
        );
        setData((prev) => prev.filter((c) => c.id !== selectedCategoria.id));
        setShowLoader(false);
        setShowSnackbar(true);
        setSnackbarMessage("Categoría eliminada correctamente");
      } catch (error) {
        setShowLoader(false);
        setShowSnackbar(true);
        setSnackbarMessage("Error al eliminar la categoría");
      }
    };

    const guardarCambios = async () => {
      setShowLoader(true);
      try {
        if (activeStep === 2) {
          await cambiarOrdenTipoParametrosTrabajo(API_URL, data);
          setParametros([...data]);
        } else if (activeStep === 1) {
          await cambiarOrdenCategoriaNombreImagen(API_URL, data);
          setCategorias([...data]);
        }
        setShowLoader(false);
        setSnackbarMessage("Cambios guardados correctamente");
        setShowSnackbar(true);
      } catch (error) {
        setShowLoader(false);
        setSnackbarMessage("Error al guardar los cambios");
        setShowSnackbar(true);
        console.error("Error saving changes:", error);
      }
    };

    const restaurarCambios = () => {
      if (activeStep === 2) {
        setData([...parametros]);
      } else if (activeStep === 1) {
        setData([...categorias]);
      }
      setSnackbarMessage("Cambios restaurados");
      setShowSnackbar(true);
    };

    return (
      <>
        <Stepper nonLinear activeStep={activeStep}>
          {steps.map((label, index) => (
            <Step key={label} completed={activeStep > index}>
              <StepLabel
                icon={index + 1}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  className="stepper-label"
                  style={{ marginTop: 8, textAlign: "center" }}
                >
                  {label}
                </div>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        {activeStep === 0 && (
          <div
            style={{ width: "500px", justifySelf: "center", marginTop: "20px" }}
          >
            <h1 style={{ justifySelf: "center" }} className="stepper-title">
              {steps[0]}
            </h1>
            <label htmlFor="name1" className="form-label">
              Nombre:
            </label>
            <input
              id="name1"
              className="form-input"
              type="text"
              name="nombre"
              placeholder="Ingresa el nombre"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
            />
          </div>
        )}

        {(activeStep === 1 || activeStep === 2) && (
          <Box sx={{ width: "100%" }}>
            <Box
              sx={{
                height: "50px",
                padding: "20px",
              }}
            >
              <Typography sx={{ fontSize: "18px" }} align="left">
                {selectedEDT?.nombre || "Estructura de Desglose de Trabajo"}
              </Typography>
            </Box>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
              }}
            >
              {fasesDeTrabajo && fasesDeTrabajo.length > 0 && (
                <Tabs
                  variant="fullWidth"
                  value={selectedFaseDeTrabajo.descripcion || null}
                  onChange={(e, value) =>
                    setSelectedFaseDeTrabajo(
                      fasesDeTrabajo.find((c) => c.descripcion === value)
                    )
                  }
                >
                  {fasesDeTrabajo &&
                    fasesDeTrabajo.length > 0 &&
                    fasesDeTrabajo.map((fase) => (
                      <Tab
                        label={fase.descripcion}
                        value={fase.descripcion}
                        key={fase.descripcion}
                      />
                    ))}
                </Tabs>
              )}
            </Box>
            <Box sx={{ padding: "20px 20px 0", display: "flex", gap: "20px" }}>
              {activeStep === 1 && (
                <CustomButton
                  background={"#223D51"}
                  color={"#FFFFFF"}
                  text="Agregar categoría de imagen"
                  height="40px"
                  fontWeight="700"
                  fontSize="14px"
                  border="1px solid #D9D9D9"
                  onClick={() => {
                    setOpenCategoriaModal(true);
                  }}
                  type="button"
                />
              )}

              {activeStep === 2 && (
                <CustomButton
                  background={"#223D51"}
                  color={"#FFFFFF"}
                  text="Agregar parámetro"
                  width="150px"
                  height="40px"
                  fontWeight="700"
                  fontSize="14px"
                  border="1px solid #D9D9D9"
                  onClick={() => {
                    setOpenParametroModal(true);
                  }}
                  type="button"
                />
              )}

              <CustomButton
                background={"#FFFFFF"}
                color={"#223D51"}
                text="Restaurar orden"
                width="150px"
                height="40px"
                fontWeight="700"
                fontSize="14px"
                border="1px solid #D9D9D9"
                onClick={restaurarCambios}
                type="button"
              />
              <CustomButton
                background={"#223D51"}
                color={"#FFFFFF"}
                text="Guardar orden"
                width="150px"
                height="40px"
                fontWeight="700"
                fontSize="14px"
                border="1px solid #D9D9D9"
                onClick={() =>
                  setShowConfirm({
                    show: true,
                    title: "Confirmación",
                    content:
                      "¿Seguro que desea cambiar el orden de estos datos?",
                    type: "cambiarOrden",
                  })
                }
                type="button"
              />
            </Box>
            <Box sx={{ padding: "20px" }}>
              <Paper sx={{ width: "100%" }}>
                <MaterialReactTable table={table} />
              </Paper>
            </Box>
          </Box>
        )}

        {activeStep === steps.length && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <h2>¡Listo! Tu EDT se ha creado con exito.</h2>
          </div>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "10px 60px",
          }}
        >
          {!newProject && (
            <CustomButton
              background={"#223D51"}
              color={"#FFFFFF"}
              text={activeStep === steps.length - 1 ? "Guardar" : "Siguiente"}
              width="150px"
              height="40px"
              fontWeight="700"
              fontSize="14px"
              border="1px solid #D9D9D9"
              onClick={() => {
                handleNext();
              }}
              type="button"
              visibility={activeStep < steps.length ? "visible" : "hidden"}
            />
          )}
        </div>
        <LoaderDialog open={showLoader} />
        <Snackbar
          open={showSnackbar}
          autoHideDuration={3000}
          onClose={() => {
            setShowSnackbar(false);
            setSnackbarMessage("");
          }}
          message={snackbarMessage}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          slotProps={{
            content: {
              sx: {
                backgroundColor: "white",
                color: "#222",
                justifyContent: "center",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "16px",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            },
          }}
        />
        <EDTCategoriaImagenModal
          selectedEDT={selectedEDT}
          API_URL={API_URL}
          open={openCategoriaModal}
          handleClose={handleCategoriaModalClose}
          categoria={selectedCategoria}
          edit={isEdit}
          selectedFaseDeTrabajo={selectedFaseDeTrabajo}
        />
        <EDTParametroModal
          selectedEDT={selectedEDT}
          API_URL={API_URL}
          open={openParametroModal}
          handleClose={handleParametroModalClose}
          parametro={selectedParametro}
          edit={isEdit}
          selectedFaseDeTrabajo={selectedFaseDeTrabajo}
        />

        <ConfirmDialog
          open={showConfirm.show}
          title={showConfirm.title}
          content={showConfirm.content}
          onClose={() => {
            setShowConfirm({
              show: false,
              title: "",
              content: "",
              type: "",
            });
            setOpenMenuIndex(null);
            setOpenMenuIndex2(null);
            setSelectedParametro(null);
            setSelectedCategoria(null);
          }}
          onConfirm={() => {
            if (showConfirm.type === "cambiarOrden") {
              guardarCambios();
            } else if (showConfirm.type === "eliminarParametro") {
              handleDeleteParametro();
            } else if (showConfirm.type === "eliminarCategoria") {
              handleDeleteCategoria();
            }

            setShowConfirm({
              show: false,
              title: "",
              content: "",
              type: "",
            });
          }}
        />
      </>
    );
  }
);

export default EDTStepper;
